import axios from 'axios';
import authHeader from './auth-header';
import { API_ADMIN_URL } from './config';

const API_URL = API_ADMIN_URL + "/";

class HistoryService {

  getHistory() {
    return axios.get(API_URL + "history", { headers: authHeader() });
  }

}

export default new HistoryService();
